module.exports = __webpack_public_path__ + "static/img/valueadd5.ae03a2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/valueadd5.png
// module id = jJYm
// module chunks = 1